export const ItemTypes = {
  STALLITEM: "stallItem",
};

export const ComponentTypes = {
  EVENT: "EVENT_COMPONENT_TYPE",
  CATERING: "CATERING_COMPONENT_TYPE",
};
